import { Environment } from './environment';

export const environment: Environment = {
  name: 'staging',
  executionStatsNodeScope: true,
  production: false,
  apiUrl: 'https://api-stg.datascient.ai',
  controlplaneUrl: 'https://api-stg.datascient.ai',
  googleDriveApiUrl: 'https://api-stg.datascient.ai',
  reasoningWsUrl: 'wss://api-stg.datascient.ai',
};
